

import React, { useEffect, useMemo, useState } from "react";
import { Api } from "../Api/Api";

const Profit = () => {
  const [payments, setPayments] = useState([]);
  const [expenses, setExpenses] = useState([]);

  const [filterType, setFilterType] = useState("all");
  const [filterDate, setFilterDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [filterMonth, setFilterMonth] = useState(
    new Date().toISOString().slice(0, 7),
  );

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
    
    const payRes = await fetch(`${Api}payments/list.php`);
    const payData = await payRes.json();

    const expRes = await fetch(`${Api}expenses/list.php`);
    const expData = await expRes.json();


      setPayments(payData.payments || []);
      setExpenses(expData.expenses || []);
    } catch (err) {
      console.error("Profit Load Error:", err);
    }
  };

  /* =========================
     DATE RANGE CHECK
  ========================= */
  const isInSelectedRange = (dateStr) => {
    if (filterType === "all") return true;

    const d = new Date(dateStr);

    if (filterType === "date") {
      return dateStr === filterDate;
    }

    if (filterType === "month") {
      return dateStr.startsWith(filterMonth);
    }

    if (filterType === "week") {
      const selected = new Date(filterDate);
      const start = new Date(selected);
      start.setDate(selected.getDate() - selected.getDay());
      start.setHours(0, 0, 0, 0);

      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      end.setHours(23, 59, 59, 999);

      return d >= start && d <= end;
    }

    return true;
  };

  /* =========================
     CALCULATE TOTALS
  ========================= */
  const report = useMemo(() => {
    let interest = 0;
    let expense = 0;

    payments.forEach((p) => {
      if (isInSelectedRange(p.payment_date)) {
        interest += Number(p.paid_amount || 0);
      }
    });

    expenses.forEach((e) => {
      if (isInSelectedRange(e.expense_date)) {
        expense += Number(e.amount || 0);
      }
    });

    return {
      interest,
      expense,
      profit: interest - expense,
    };
  }, [payments, expenses, filterType, filterDate, filterMonth]);

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-6xl mx-auto space-y-6">
        {/* HEADER */}
        <div>
          <h1 className="text-2xl font-black text-gray-900">PROFIT REPORT</h1>
          <p className="text-gray-600 text-sm">Interest − Expenses</p>
        </div>

        {/* FILTER BAR */}
        {/* <div className="bg-white p-4 rounded-xl border flex flex-wrap gap-4 items-center justify-between">
          <div className="flex gap-4 items-center">
            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              className="border px-3 py-2 rounded font-bold text-xs uppercase"
            >
              <option value="all">All</option>
              <option value="date">Specific Date</option>
              <option value="week">Weekly</option>
              <option value="month">Monthly</option>
            </select>

            {["date", "week"].includes(filterType) && (
              <input
                type="date"
                value={filterDate}
                onChange={(e) => setFilterDate(e.target.value)}
                className="border px-3 py-2 rounded"
              />
            )}

            {filterType === "month" && (
              <input
                type="month"
                value={filterMonth}
                onChange={(e) => setFilterMonth(e.target.value)}
                className="border px-3 py-2 rounded"
              />
            )}
          </div>
        </div> */}

        {/* FILTER BAR - Responsive Version */}
<div className="bg-white p-4 rounded-xl border flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
  
  {/* Filter Type Dropdown */}
  <div className="flex flex-col xs:flex-row gap-3 items-start xs:items-center w-full sm:w-auto">
    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest sm:hidden">
      Filter By:
    </label>
    <select
      value={filterType}
      onChange={(e) => setFilterType(e.target.value)}
      className="border px-3 py-2 rounded font-bold text-xs uppercase bg-white w-full sm:w-40 focus:ring-2 focus:ring-black outline-none"
    >
      <option value="all">All Time</option>
      <option value="date">Specific Date</option>
      <option value="week">Weekly</option>
      <option value="month">Monthly</option>
    </select>
  </div>

  {/* Conditional Date/Month Inputs */}
  {filterType !== "all" && (
    <div className="flex flex-col gap-2 w-full sm:w-auto">
      <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest sm:hidden">
        Select {filterType === "month" ? "Month" : "Date"}:
      </label>
      
      {["date", "week"].includes(filterType) && (
        <input
          type="date"
          value={filterDate}
          onChange={(e) => setFilterDate(e.target.value)}
          className="border px-3 py-2 rounded font-medium text-sm w-full sm:w-auto focus:ring-2 focus:ring-black outline-none"
        />
      )}

      {filterType === "month" && (
        <input
          type="month"
          value={filterMonth}
          onChange={(e) => setFilterMonth(e.target.value)}
          className="border px-3 py-2 rounded font-medium text-sm w-full sm:w-auto focus:ring-2 focus:ring-black outline-none"
        />
      )}
    </div>
  )}
</div>

        {/* SUMMARY */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-xl border">
            <p className="text-sm text-gray-500 font-bold">
              Interest Generated
            </p>
            <p className="text-2xl font-black mt-2 text-green-700">
              ₹{report.interest.toLocaleString()}
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl border">
            <p className="text-sm text-gray-500 font-bold">Expenses</p>
            <p className="text-2xl font-black mt-2 text-red-600">
              ₹{report.expense.toLocaleString()}
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl border-2 border-black">
            <p className="text-sm text-gray-500 font-bold">Net Profit</p>
            <p
              className={`text-3xl font-black mt-2 ${
                report.profit >= 0 ? "text-green-800" : "text-red-700"
              }`}
            >
              ₹{report.profit.toLocaleString()}
            </p>
          </div>
        </div>

        {/* BREAKDOWN TABLE */}
        <div className="bg-white rounded-xl border overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-6 py-3 text-left font-bold">Type</th>
                <th className="px-6 py-3 text-right font-bold">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t">
                <td className="px-6 py-4 font-semibold">Interest Income</td>
                <td className="px-6 py-4 text-right font-bold text-green-700">
                  ₹{report.interest.toLocaleString()}
                </td>
              </tr>
              <tr className="border-t">
                <td className="px-6 py-4 font-semibold">Expenses</td>
                <td className="px-6 py-4 text-right font-bold text-red-600">
                  − ₹{report.expense.toLocaleString()}
                </td>
              </tr>
              <tr className="border-t bg-gray-50">
                <td className="px-6 py-4 font-black">NET PROFIT</td>
                <td className="px-6 py-4 text-right font-black">
                  ₹{report.profit.toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Profit;
